import { motion } from "framer-motion";
import SectionHeading from "../../SectionHeading";
import { revealOnce, stagger } from "../../motion";
import html from "../../../Assets/Images/html.png";
import css from "../../../Assets/Images/css-3.png";
import tailwind from "../../../Assets/Images/tailwind.512x323.png";
import javascript from "../../../Assets/Images/javascript.png";
import reactjs from "../../../Assets/Images/react.png";
import mySQL from "../../../Assets/Images/mysql.png";
import dbeaver from "../../../Assets/Images/dbeaver.png";
import AD from "../../../Assets/Images/adbig-removebg-preview.png";
import sophos from "../../../Assets/Images/sophos.512x512.png";
import odoo from "../../../Assets/Images/odoo-removebg-preview.png";
import endpoint from "../../../Assets/Images/endpoint_central-removebg-preview.png";
import intune from "../../../Assets/Images/microsoft-intune-removebg-preview.png";
import ME from "../../../Assets/Images/MEdownload-removebg-preview.png";
import vercel from "../../../Assets/Images/Vercel_favicon-removebg-preview.png";
import unifi from "../../../Assets/Images/unifi_icon-removebg-preview.png";
import github from "../../../Assets/Images/github.512x500.png";
import azure from "../../../Assets/Images/Screen-Shot-2021-08-06-at-1.48.52-PM-removebg-preview.png";
import "../../css/Skills.css";

const SKILLS = [
  // IT Systems Engineering tools first
  { name: "Active Directory", img: AD },
  { name: "Azure", img: azure },
  { name: "Intune", img: intune },
  { name: "Endpoint Central", img: endpoint },
  { name: "ManageEngine", img: ME },
  { name: "Sophos", img: sophos },
  { name: "UniFi", img: unifi },
  { name: "Odoo", img: odoo },
  { name: "DBeaver", img: dbeaver },
  // Development stack
  { name: "React", img: reactjs },
  { name: "JavaScript", img: javascript },
  { name: "HTML", img: html },
  { name: "CSS", img: css },
  { name: "Tailwind", img: tailwind },
  { name: "MySQL", img: mySQL },
  { name: "GitHub", img: github },
  { name: "Vercel", img: vercel },
];

const iconVariant = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.4 } },
};

const Skills = () => {
  return (
    <section className="section skills">
      <div className="container">
        <SectionHeading
          eyebrow="Skills"
          title="Technologies I work with"
          subtitle="A toolkit spanning software development, databases, networking, security, and endpoint management."
        />

        <motion.div className="skills__grid" variants={stagger} {...revealOnce}>
          {SKILLS.map((skill) => (
            <motion.div
              key={skill.name}
              className="skill-tile"
              variants={iconVariant}
              title={skill.name}
            >
              <img src={skill.img} alt={skill.name} loading="lazy" />
              <span>{skill.name}</span>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Skills;
